/**
 * AI Assist Insights Page (Web)
 * Placeholder for AI assist insights.
 */

import { Container, Typography, Box } from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function AIAssistInsightsPage() {
  return (
    <AuthenticatedLayout>
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            AI Assist Insights
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Insights feature coming soon...
          </Typography>
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
}

